import { render, staticRenderFns } from "./SistemaIndisponivel.vue?vue&type=template&id=68aef96a"
import script from "./SistemaIndisponivel.vue?vue&type=script&lang=js"
export * from "./SistemaIndisponivel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports